export const DOCUMENT = 'document';
export const DOCUMENT_EXECUTED = 'document_executed';
export const COLLECTION = 'collection';